import { render, staticRenderFns } from "./CustomerGroupInputs.vue?vue&type=template&id=1f8b01fe&"
import script from "./CustomerGroupInputs.vue?vue&type=script&lang=ts&"
export * from "./CustomerGroupInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports